import Header from "@/components/layout/header/Header";
import SimulationSelector from "./components/selector/SimulationSelector";
import UserInfoDisplay from "./components/userInfo/UserInfo";
import type { dashboardHeaderProps } from "./types.props";
import BackButton from "./components/backButton/BackButton";
import { useAuth } from "@/providers/AuthProvider";

interface ModifiedDashboardHeaderProps extends dashboardHeaderProps {
    backButtonPath?: string;
}

const DashboardHeader: React.FC<ModifiedDashboardHeaderProps> = ({
    simulations,
    selectedSimulationId,
    isLoading,
    onSimulationChange,
    backButtonPath,
}) => {
    const { user } = useAuth();

    const logoPath =
        user?.role === "Coordinador de curso"
            ? "/coordinator-dashboard"
            : "/student-dashboard";
    return (
        <Header
            variant="dashboard"
            leftContent={backButtonPath ? <BackButton to={backButtonPath} /> : null}
            centerContent={
                <SimulationSelector
                    simulations={simulations}
                    selectedId={selectedSimulationId}
                    onChange={onSimulationChange}
                    isLoading={isLoading}
                />
            }
            rightContent={!backButtonPath ? <UserInfoDisplay /> : null}
            logo={backButtonPath ? false : true}
            logoLink={logoPath}
        />
    );
};

export default DashboardHeader;
